import DeviceIssueTip from "components/Home/Modals/DeviceIssueTip/DeviceIssueTip";
import React from "react";

const DPModalBody = ({ onDismiss }) => {
  return (
    <div>
      <div>
        <DeviceIssueTip />
      </div>
      <br />
      <br />
      <button className={`growth-button confirm-button`} onClick={onDismiss}>
        Ok
      </button>
    </div>
  );
};

export default DPModalBody;
